export const materialUnitOptions = [
  { value: "item", label: "Item" },
  { value: "tonns", label: "Tonns" },
  { value: "Kg", label: "KG" },
  { value: "g", label: "G" },
  { value: "lbs", label: "LBS" },
  { value: "litre", label: "Litre" },
  { value: "ml", label: "ML" },
  { value: "sqm", label: "SQM" },
  { value: "meter", label: "Meter" },
];

// Supply/Apply option values must be capitalized — that's how the backend
// stores them and how the BOQ display logic compares (e.g. for showing
// the lead-time field). Mirrors reno-portal's supplyApplyOptions exactly.
export const supplyApplyOptions = [
  { value: "Supply", label: "Supply" },
  { value: "Apply", label: "Apply" },
  { value: "Supply and Apply", label: "Supply and Apply" },
];

// Maps any-casing supply/apply string to its canonical capitalized form.
// Existing BOQs may have been saved as "supply" / "apply" — normalize on
// read before comparing or rendering.
export const normalizeSupplyApply = (val) => {
  if (val == null) return null;
  const lower = String(val).trim().toLowerCase();
  if (lower === "supply") return "Supply";
  if (lower === "apply") return "Apply";
  if (lower === "supply and apply") return "Supply and Apply";
  return val;
};

// True when the supply/apply value triggers a (mandatory in contractor /
// optional in portal) `lead_time` field. Pure / casing-insensitive.
export const requiresLeadTime = (val) => {
  if (val == null) return false;
  const lower = String(val).trim().toLowerCase();
  return lower === "supply" || lower === "supply and apply";
};

export const boqTypeOptions = [
  { value: "Materials", label: "Materials" },
  { value: "Activities", label: "Activities" },
];

// Backend returns a default placeholder image entry (id:0 + this URL)
// whenever a BOQ has no user-uploaded image. We still show it in the
// image cell — but treat it as "not a real user image" for delete/replace
// behavior (no DELETE call against id:0, since it's not a real file).
export const BOQ_PLACEHOLDER_IMAGE_UUID =
  "e56d3d53-e335-425f-990e-16e6b2bbee1b";

export const isPlaceholderBoqImage = (img) => {
  if (!img) return false;
  if (img.id === 0) return true;
  if (
    typeof img.image === "string" &&
    img.image.includes(BOQ_PLACEHOLDER_IMAGE_UUID)
  ) {
    return true;
  }
  return false;
};

// First image entry from a BOQ — null when the array is missing/empty.
// Placeholders ARE returned (so the cell still renders something); the
// caller decides whether to gate delete on `isPlaceholderBoqImage`.
export const getBoqDisplayImage = (boq) => {
  const arr = boq?.image;
  if (!Array.isArray(arr) || arr.length === 0) return null;
  const first = arr[0];
  if (!first || !first.image) return null;
  return first;
};
